const e = {
  page404: {
    title: "It seems like you got lost",
    message: "Did you get lost?",
    action_btn: "Back to the beginning"
  },
  address: {
    title: "Address",
    type: {
      personal: "Personal",
      company: "Company"
    },
    organisation: {
      label: "Company name"
    },
    name: {
      first_name: "First name",
      last_name: "Last name",
      label: "Contact person"
    },
    contact_person: {
      first_name: "First name",
      last_name: "Last name",
      label: "Contact person"
    },
    street: {
      label: "Street and number",
      address1: "Address 1",
      address2: "Address 2"
    },
    city: {
      label: "City"
    },
    postal_code: {
      label: "Postal code"
    },
    country_code: {
      label: "Country"
    },
    company_data: {
      title: "Company data"
    },
    company_id: {
      label: "Company ID"
    },
    tax_id: {
      label: "Tax ID"
    },
    vat_id: {
      label: "VAT  ID"
    }
  },
  empty_state: {
    title: "Nothing to show here..."
  },
  profile: {
    emails: {
      label: "Email (you can enter more email addresses)"
    },
    email: {
      label: "Email"
    },
    phone: {
      label: "Phone",
      short: "Phone"
    }
  },
  validation: {
    country_required: "Please enter your country",
    company_id: {
      not_valid: "Invalid company ID"
    },
    tax_id: {
      not_valid: "Invalid TaxID"
    },
    vat_id: {
      not_valid: "Invalid VAT ID"
    }
  },
  general: {
    back: "Back",
    cancel: "Cancel",
    close: "Close",
    remove: "Remove",
    optional: "Optional",
    period: {
      months: "{period, plural, one {# month} other {# months}}",
      years: "{period, plural, one {# year} other {# years}}",
      explicit: "Period",
      short: {
        months: "{ period, plural, one {month} other {# months} }",
        years: "{ period, plural, one {year} other {# yrs} }"
      },
      next: {
        months: "{ period, plural, one {next month} other {next # months} }",
        years: "{ period, plural, one {next year} other {next # years} }",
        short: {
          months: "{ period, plural, one {next month} other {next # months} }",
          years: "{ period, plural, one {next year} other {next # yrs} }"
        }
      },
      per: {
        months: "{ period, plural, one {monthly} other {for # months} }",
        years: "{ period, plural, one {yearly} few {for #  years} other {for # years} }",
        short: {
          months: "{ period, plural, one {/month} other {/# months} }",
          years: "{ period, plural, one {/year} other {/# years} }"
        }
      }
    },
    or: "or",
    recommended: "recommended",
    settings: "Settings",
    edit: "Edit",
    save: "Save",
    save_changes: "Save changes",
    reset_form: "Reset form",
    not_available: "Not available",
    unknown_error: "Unknown error",
    unknown_error_id: "Unknown error ({id})",
    something_went_wrong: "We appologize, but this is unexpected result, something went wrong",
    link: "link",
    buy: "buy"
  },
  capslock_hint: {
    line1: "Caps Lock",
    line2: "is on"
  },
  ws_array_input: {
    some_filtered: "Some results are not valid."
  },
  ws_places_input: {
    no_results: "Place not found, please try a less specific address"
  },
  ws_uploader: {
    validation: {
      file_type: "File type is not valid.",
      file_size: "File size is over limit ({limit})"
    },
    status: {
      label: "Status",
      value: {
        uploaded: "uploaded",
        uploading: "uploading",
        failed: "failed",
        idle: "idle"
      }
    },
    action: {
      title: "Upload invoices",
      text1: "Drag and drop or ",
      link: "choose file",
      text2: ".",
      abort_tooltip: "Abort upload"
    },
    remove_btn: "Remove"
  },
  ws_table: {
    filter: {
      fulltext_title: "Fulltext search",
      data_title: "Search",
      clear_filters: "Clear all filters",
      from: "From",
      to: "to"
    },
    label: {
      bulk_actions: "Bulk actions",
      cancel_selection: "Cancel selection",
      item_selected: "items selected",
      selected: "Selected",
      filterby: "Filter by:",
      records_per_page: "Records per page:",
      select_all: "Select all"
    }
  },
  ws_password_strength: {
    rule1: "a minimum of 8 characters",
    rule2: "lowercase and uppercase letters",
    rule3: "at least one digit",
    rule4: "at least one special character"
  },
  ws_password_confirmation_input: {
    passwords_do_not_match: "Passwords do not match!"
  },
  ws_two_factor_authentication_input: {
    on_cooldown_one: "You can resend the code again in {{count}} second.",
    on_cooldown_few: "You can resend the code again in {{count}} seconds.",
    on_cooldown_other: "You can resend the code again in {{count}} seconds.",
    resend_code: "Resend code",
    code_being_sent: "Sending 2FA code...",
    code_sent_successfully: "2FA code sent successfully",
    error_sending_code: "Error sending 2FA code.",
    invalid_code_pasted: "Invalid 2FA code was pasted. Please enter a valid 2FA code."
  },
  generate_random: "Generate random",
  copy: {
    copy: "Copy",
    copied: "Copied",
    saved_in_clipboard: "Saved in clipboard"
  },
  out_modal: {
    title: "Sorry, your browser<br>is not up to date",
    text: "Please upgrade it to the newest version or try installing a different browser.",
    delimiter_text: "We can help"
  },
  buttons: {
    ok_thanks: "Ok, Thanks"
  },
  payment_cards: {
    ending_with: "Ending with",
    active: "Active"
  },
  ws_sub_items_price_summary: {
    current_price: "Service price (the current billing period)",
    due_now: "Due now",
    next_period_subtraction_warning: "* The price will be deducted from the next billing period",
    next_price: "Service price (the next billing period)"
  },
  dialog_footer: {
    cannot_submit_empty_form: "It is not possible to submit an empty form."
  },
  price_badge: {
    including_vat: "(including VAT)",
    excluding_vat: "(without VAT)"
  },
  login_pages: {
    footer: {
      help: "Help",
      terms: "Terms",
      privacy: "Privacy"
    },
    help: {
      title: "Need any help?",
      text: "You can always have a look at our <a href='{kb_url}' target='_blank'>knowledge database </a> or contact our <a href='{support_url}' target='_blank'>support</a>."
    }
  },
  message_service: {
    error: {
      axios: {
        title: "Network Error",
        text: "Unable to connect"
      },
      unexpected: {
        title: "Error",
        text: "Unexpected error"
      }
    }
  }
}, t = {
  wsk: e
};
export {
  t as default,
  e as wsk
};
//# sourceMappingURL=wsk.en-US-cb313aa1.js.map
